import React from 'react';
import styled from 'styled-components';
import Card from '../components/card'

const Testimonials = styled.div`
  width:100vw;
  max-width:100%;
  display: grid;
  justify-items: center;
  grid-row-gap: .5rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
  
  /*desktop version*/
@media (min-width: 750px){
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: .5rem;
  margin-top: calc(100vw/50*1.563);
}
`
const Title = styled.h2`
  display:grid;
  place-content:center;
  font-size: .9rem;

  /*desktop version*/
  @media (min-width: 750px){
    font-size: 1.8rem;
  }
`
const TestimonialsSection = ({ cards }) => {
  return (
    <>
      <Title>Vrei să te alături comunității?</Title>
      <Testimonials>
        {cards.map((node) =>
          <Card key={node.name}
            name={node.name}
            text={node.testimonial}
            position={node.job} />)}
      </Testimonials>
    </>
  )
}

export default TestimonialsSection;
